import {BrowserRouter, Routes, Route} from 'react-router-dom';

import Header from './components/Header';
import MainContainer from './components/MainContainer';
import WorkDetail from './components/WorkDetail';
import WorkMore from './components/WorkMore';
import ScrollToTop from './components/ScrollToTop';

import './css/common.css';

function App() {
    return (
        <>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <ScrollToTop />
                <Header />
                <Routes>
                    <Route path='/' element={<MainContainer />}/>
                    <Route path='/workdetail/:workId' element={<WorkDetail />}/>
                    <Route path='/workmore' element={<WorkMore />}/>
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
